module.exports = __webpack_public_path__ + "img/bnr_ul.081b9fe2.png";